
// Argon Dashboard 2 MUI layouts
import AgregarUsuarios from "layouts/agregarUsuario";
import SignIn from "layouts/authentication/sign-in";
import Dashboard from "layouts/dashboard";
import HistorialAcciones from "layouts/historialAcciones";
import Retiros from "layouts/retiros";
import SubirExcel from "layouts/subirExcel";
import Usuarios from "layouts/usuarios";
import Comprobantes from "layouts/comprobantes";
import Ajustes from "layouts/ajustes";
// Argon Dashboard 2 MUI components
import '@fortawesome/fontawesome-free/css/all.min.css';
import ArgonBox from "components/ArgonBox";
import CustomIcon from "components/CustomIcon";
import SubirComprobante from "layouts/subirComprobante";
import Soporte from "layouts/soporte";
import { IoCloudDownloadOutline } from "react-icons/io5";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";


const routes = [
  {
    type: "route",
    name: "Inicio",
    nameKey: "nav.home",
    key: "dashboard",
    route: "/dashboard",
    icon: <CustomIcon iconName="tv-minimal" color="dark" fontSize="20px" />,
    component: <Dashboard />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Usuarios",
    nameKey: "nav.users",
    key: "usuarios",
    route: "/usuarios",
    icon: <CustomIcon iconName="user-round" color="dark" fontSize="20px" />,
    component: <Usuarios />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Retiros",
    nameKey: "nav.withdrawals",
    key: "retiros",
    route: "/retiros",
    icon: <CustomIcon iconName="banknote-arrow-down" color="dark" fontSize="24px" />,
    component: <Retiros />,
    includeInSidebar: true,
  },
  {
    type: "title",
    title: "Agregar Usuarios",
    titleKey: "nav.addUsersSection",
    key: "agregar-usuarios-title",
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Agregar usuario",
    nameKey: "nav.addUser",
    key: "agregar-usuario",
    route: "/agregar-usuario",
    icon: <CustomIcon iconName="user-round-plus" color="dark" fontSize="20px" />,
    component: <AgregarUsuarios />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Carga masiva",
    nameKey: "nav.bulkUpload",
    key: "subir-excel",
    route: "/subir-excel",
    icon: <CustomIcon iconName="upload" color="dark" fontSize="20px" />,
    component: <SubirExcel />,
    includeInSidebar: true,
  },
  {
    type: "title",
    title: "Descargar comprobante",
    titleKey: "nav.downloadReceiptSection",
    key: "descargar-comprobante-title",
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Descargar comprobante",
    nameKey: "nav.downloadReceipt",
    key: "comprobantes",
    route: "/comprobantes",
    icon: <IoCloudDownloadOutline color="dark" fontSize="20px" />,
    component: <Comprobantes />,
    includeInSidebar: true,
  },
  {
    type: "title",
    title: "Comprobantes",
    titleKey: "nav.receiptsSection",
    key: "comprobantes-title",
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Adjuntar comprobante",
    nameKey: "nav.attachReceipt",
    key: "subir-comprobante",
    route: "/subir-comprobante",
    icon: <CustomIcon iconName="receipt-text" color="dark" fontSize="20px" />,
    component: <SubirComprobante />,
    includeInSidebar: true,
  },
  {
    type: "title",
    title: "Historial",
    titleKey: "nav.historySection",
    key: "historial-title",
    includeInSidebar: false,
  },
  {
    type: "route",
    name: "Historial de acciones",
    nameKey: "nav.actionHistory",
    key: "historial-acciones",
    route: "/historial-acciones",
    icon: <CustomIcon iconName="history" color="dark" fontSize="20px" />,
    component: <HistorialAcciones />,
    includeInSidebar: false,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: (
      <ArgonBox component="i" color="warning" fontSize="20px" className="ni ni-cloud-upload-96" />
    ),
    component: <SignIn />,
    includeInSidebar: false,
  },
  {
    type: "title",
    title: "Ayuda",
    titleKey: "nav.helpSection",
    key: "ayuda-title",
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Atención al cliente",
    nameKey: "nav.support",
    key: "soporte",
    route: "/soporte",
    icon: <CustomIcon iconName="users" color="dark" fontSize="20px" />,
    component: <Soporte />,
    includeInSidebar: true,
  },
  {
    type: "title",
    title: "Configuración",
    titleKey: "nav.settingsSection",
    key: "configuracion-title",
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Ajustes",
    nameKey: "nav.settings",
    key: "ajustes",
    route: "/ajustes",
    icon: <SettingsOutlinedIcon sx={{ fontSize: '20px', color: 'inherit' }} />,
    component: <Ajustes />,
    includeInSidebar: true,
  },
];

export default routes;
